export const Marquee = ({ items, testId = "editorial-marquee" }) => {
  const row = items.map((i) => i.toUpperCase()).join("   •   ") + "   •   ";
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden border-y border-white/5 bg-[#0A0B0E] py-6"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((i) => (
          <span
            key={i}
            className="text-outline pr-10 font-display text-4xl tracking-[0.12em] sm:text-6xl"
          >
            {row}
          </span>
        ))}
      </div>
    </div>
  );
};
